import React from 'react'
import { useTranslation } from 'react-i18next'

interface SectionTitleProps {
  titleKey: string
}

const SectionTitle: React.FC<SectionTitleProps> = ({ titleKey }) => {
  const { t } = useTranslation()

  return (
    <div className="font-semibold font-['IBM_Plex_Sans_Arabic'] text-base text-black">
      {t(titleKey)}
    </div>
  )
}

export default SectionTitle

